import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'ODS': {
      'TITULO': 'Şirket Profili',
      'TOOLBAR': {
        'NUEVA': 'Bir şirket için profil oluşturun',
        'EDITAR': 'Bu şirketin profil verilerini değiştirebilirsiniz',
        'CAMBIOS': '(değişiklikler otomatik olarak kaydedilir)',
        'DESCARGAR': 'Şirket bilgilerini indirin'
      },
      'FORMULARIOS': {
        '0': 'Şirket Bilgisi',
        '1': 'Proje Müdürü',
        '2': 'İK müdürü',
        '3': 'Bilgi Teknolojileri Yöneticisi',
      },
      'BOTONES': {
        'BACK': 'Öncesi',
        'NEXT': 'Sonraki',
        'ACEPTAR': 'Kabul etmek'
      },
      'MODALES': {
        'EMPRESA_EXISTE': 'Belirtilen ada sahip kayıtlı bir şirket zaten var, şirketi başka bir adla yeniden oluşturmayı deneyin',
        'ERROR_GUARDADO': 'Şirket oluşturulurken bir hata oluştu, lütfen daha sonra tekrar deneyin.',
        'GUARDANDO': 'Değişiklikleri kaydediyor',
        'GENERANDO_PDF': 'PDF dosyası oluşturuluyor, bir dakika bekleyin'
      },
      'CAMPOS': {
        'institutoEmpresa': 'Komisyoncu',
        'country_application': 'komisyoncu ülke',
        'nombreEmpresa': 'Şirket',
        'shortName': 'Şirket kısa adı',
        'nombrePublicacion': 'Yayınlanacak şirket adı',
        'account_id': 'Hesap Kimliği',
        'idSalesForce': 'Satış Gücü Kimliği',
        'codigoProyecto': 'proje kodu',
        'anioFundacion': 'kuruluş yılı',
        'empleadosCompleto': 'Tam zamanlı çalışanlar',
        'empleadosParcial': 'Yarı zamanlı çalışanlar',
        'totalColaboradores': 'Toplam ortak çalışan sayısı',
        'sector': 'Bir sektör seçin',
        'subSector': 'Bir alt sektör seçin',
        'multinacional': 'çok uluslu',
        'name_multinational_group':'Nombre del gruÇok uluslu grubun adı',
        'region': 'Bir bölge seçin',
        'pais': 'Ülke',
        'estado': 'Eyalet, şehir veya il',

        'nombreResponsable': 'İsim',
        'apellidoResponsable': 'Soyadı',
        'emailResponsable': 'E-posta',
        'telResponsable': 'Telefon',
        'extResponsable': 'Uzantı',
        'celResponsable': 'Mobil',

        'nombreRH': 'Ad Soyad',
        'emailRH': 'E-posta',
        'telRH': 'Telefon',
        'extRH': 'Uzantı',
        'celRH': 'Mobil',

        'nombreTI': 'Ad Soyad',
        'emailTI': 'E-posta',
        'telTI': 'Telefon',
        'extTI': 'Uzantı',
        'celTI': 'Mobil',

        'PDF_sector': 'sektör',
        'PDF_subSector': 'alt sektör',
        'PDF_region': 'Bölge',
        'PDF_fecha': 'Tarih:',
        'PDF_hora': 'Saat:',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': 'Evet',
          '2': 'Numara',
        }
      },
      'ERRORES': {
        'minlength': 'İzin verilen minimum karakter sayısını girmediniz',
        'maxlength': 'İzin verilen maksimum karakter sayısını aştınız',
        'max': 'Girilen sayı izin verilen maksimum sayıyı aşıyor',
        'min': 'Girilen sayı, gereken minimum sayının altında',
        'pattern': 'Girilen metin, bu alanda izin verilmeyen karakterler içeriyor',
        'email': 'Girilen metin doğru e-posta biçiminde değil',
        'required': 'Bu alan gereklidir',
        'TEXT_ESPEC_ANIOFUNDA':'Girilen tarih izin verilen maksimum tarihi aşıyor',
      }
    }
  }
};
